<div class="notification notification--{{ data.type }}">
  <div class="notification__container">
    <!-- Error icon -->
    @switch (data.type) {
      <!-- Error icon -->
      @case ('error') {
        <div class="notification__action notification__action--{{ iconPosition }}">
          <mat-icon class="icon icon-20 icon-v-middle icon-white">warning</mat-icon>
        </div>
      }
      <!-- Success icon -->
      @case ('success') {
        <div class="notification__action notification__action--{{ iconPosition }}">
          <mat-icon class="icon icon-20 icon-v-middle icon-white">success</mat-icon>
        </div>
      }
    }

    <div class="notification__content">
      @if (data.title && data.translate) {
        <h5 class="notification__title">{{ data.title | transloco }}</h5>
      }
      @if (data.title && !data.translate) {
        <h5 class="notification__title">{{ data.title }}</h5>
      }

      <div class="notification__message">
        @if (data.translate) {
          <div [innerHtml]="data.message | transloco"></div>
        }
        @if (!data.translate) {
          <div [innerHtml]="data.message"></div>
        }
      </div>
    </div>

    <!-- Close actions -->
    @if (!handleAutoclose) {
      <mat-icon
        class="notification__action notification__action--right icon icon-16 icon-v-middle icon-white"
        aria-label="Close"
        (click)="dismiss()"
        >close</mat-icon
      >
    }
  </div>
</div>
